import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    backgroundColor: capitalDesignTokens.semanticColors.background.disabled
  },
  content: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    overflow: 'hidden'
  },
  storyContent: {
    position: 'relative',
    display: 'flex',
    flex: 1,
    minWidth: 0,
    overflow: 'hidden'
  },
  storyPreviewContainer: {
    height: '100%',
    width: '100%',
    display: 'flex',
    overflow: 'auto'
  },
  storyPreviewWrapper: {
    minWidth: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexShrink: 0,
    overflow: 'hidden'
  },
  storyPreview: {
    width: '794px',
    paddingY: '36px',
    display: 'flex',
    flexShrink: 0,
    margin: 0,
    transformOrigin: 'top center'
  },
  loadingSpinner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%'
  },
  toolbarContainer: {
    position: 'absolute',
    bottom: '24px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 1000
  },
  pdfPreview: {
    height: '100%',
    width: '794px',
    display: 'flex',
    border: 'none'
  }
});
